import { render, staticRenderFns } from "./UpgradePlanCardOneLight.vue?vue&type=template&id=63b972e9"
import script from "./UpgradePlanCardOneLight.vue?vue&type=script&lang=js"
export * from "./UpgradePlanCardOneLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports